import { useState } from 'react';
import { SellerLayout } from '../components/SellerLayout';
import { InventorySection } from '../components/InventorySection';
import { ListingModal } from '../components/ListingModal';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import type { Listing } from '../types';

export function SellerInventoryPage() {
  useDocumentTitle('Inventory');
  const [isListingModalOpen, setIsListingModalOpen] = useState(false);
  const [editingListing, setEditingListing] = useState<Listing | null>(null);
  const [inventoryRefreshTrigger, setInventoryRefreshTrigger] = useState(0);

  const handleAddListing = () => {
    setEditingListing(null);
    setIsListingModalOpen(true);
  };

  const handleEditListing = (listing: Listing) => {
    setEditingListing(listing);
    setIsListingModalOpen(true);
  };

  const handleListingSuccess = () => {
    setInventoryRefreshTrigger((prev) => prev + 1);
  };

  return (
    <SellerLayout>
      <InventorySection
        onAddListing={handleAddListing}
        onEditListing={handleEditListing}
        refreshTrigger={inventoryRefreshTrigger}
      />

      <ListingModal
        isOpen={isListingModalOpen}
        onClose={() => setIsListingModalOpen(false)}
        onSuccess={handleListingSuccess}
        listing={editingListing}
      />
    </SellerLayout>
  );
}
